import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { CommonService } from '../../../common/service/common.service';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';

@Component({
	selector: 'app-blog',
	templateUrl: './blog.component.html',
	styleUrls: ['./blog.component.scss'],
	providers: [CommonService]
})
export class BlogComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	blog: FormGroup;
	blogContent = [];
	users = [];
	userList = [];
	filteredList = [];
	canEdit = true;
	allSaved = true; //Do some field have some unsaved change?
	private tempElement // Hold the changed Element reference
	private query = '';
	private token;

	constructor(private fb: FormBuilder, private limitFlowProposalService: LimitFlowProposalService, private flashMessagesService: FlashMessagesService, private commonService: CommonService) {
		this.blog = fb.group({
			ID: '',
			Nome: '',
			Mensagem: ['', Validators.compose([Validators.required])]
		});
	}

	ngOnInit() {
		console.log("Load Blog Tab");
		this.token = localStorage.getItem('yara.token');
		this.manageFields();
		this.getProposalBlog();
		this.getUsers();
	}

	manageFields() {
		this.canEdit = !(this.proposalStatus == 'AA' || this.proposalStatus == 'XE' || this.proposalStatus == 'XR');
		(<HTMLInputElement>document.getElementById("message")).disabled = !this.canEdit;
	}

	getProposalBlog() {
		this.limitFlowProposalService.getProposalBlog(this.proposalID).subscribe(result => {
			if (result.Success) {
				console.log(result.Result);
				this.blogContent = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	filter(event) {
		this.query = event.target.value;
		this.tempElement = (<HTMLInputElement>document.getElementById("user-name"));
		this.allSaved = false;

		if (this.query !== "") {
			this.filteredList = this.userList.filter(function (el) {
				return el.userName.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
			}.bind(this));
		} else {
			this.filteredList = [];
		}

		if ($("#user-id").val() != "") {
			$("#user-id").val("");
			this.tempElement.value = "";
			this.filteredList = [];
		}
	}

	select(item) {
		this.tempElement.value = item.userName;
		var elementId = this.tempElement = (<HTMLInputElement>document.getElementById("user-id"));
		elementId.value = item.userID;
		this.filteredList = [];
		this.allSaved = true;
	}

	insertBlogComment(blog: any) {
		if (this.blog.controls.Mensagem.value.length <= 5000) {
			blog.Area = this.proposalID;
			blog.ContaClienteID = this.accountClientID;
			blog.ParaID = (<HTMLInputElement>document.getElementById("user-id")).value;

			this.limitFlowProposalService.insertBlogComment(blog).subscribe(result => {
				if (result.Success) {
					this.getProposalBlog();
					this.blog.reset();
					$("#user-name").val("");
					$("#user-id").val("");

					this.flashMessagesService.show("Mensagem enviada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		} else {
			this.flashMessagesService.show("Esta mensagem excedeu o máximo de caracteres permitidos. (max. 5000 caracteres)", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getUsers() {
		this.limitFlowProposalService.getBlogUserList().subscribe(result => {
			this.users = result.Result;
			this.users.forEach(user => {
				this.userList.push({
					userName: user.Nome + " (" + user.Login + ")",
					userID: user.ID
				});
			});
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/blog/blog.component.ts